import { AfterViewInit, Component, Input } from '@angular/core';
import { GeogebraService } from '../../service/geogebra.service';
import { StorageService } from '@tekman/shared/service';
import { FeaturitWrapperService } from '@tekman/onmat/service/onmat';
import { Language } from '@tekman/onmat/constants';

declare const GGBApplet: any;

@Component({
  selector: 'geogebra',
  templateUrl: './geogebra.component.html',
  styleUrls: ['./geogebra.component.scss'],
})
export class GeogebraComponent implements AfterViewInit {
  @Input() value = '';

  constructor(
    private geogebraService: GeogebraService,
    private localStorage: StorageService,
    private featuritWrapperService: FeaturitWrapperService
  ) {}

  ngAfterViewInit() {
    this.loadGeogebra();
  }

  loadGeogebra() {
    const lang = Language[this.localStorage.languageLicense as keyof typeof Language];
    this.geogebraService.getFilesByFolder(`tools/GEOGEBRA/${lang}/${this.value}`).subscribe(async files => {
      if (files.length === 0) {
        this.featuritWrapperService.track(this.featuritWrapperService.eventKeys.geogebraError, {
          geogebra: this.value,
          geogebraLanguage: lang,
        });
      }
      const response = await fetch(files[0]);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const parameters = {
          ggbBase64: reader.result?.toString(),
          prerelease: false,
          borderColor: '#FFFFFF',
          showAlgebraInput: false,
          showResetIcon: true,
          enableLabelDrags: false,
          enableRightClick: false,
          capturingThreshold: null,
          showToolBarHelp: false,
          errorDialogsActive: true,
          useBrowserForJS: false,
          enableShiftDragZoom: false,
          scale: 0.88,
          autoHeight: true,
        };
        const ggbApplet = new GGBApplet(parameters, true);
        ggbApplet.inject(`ggb-element-${this.value}`);
      };

      reader.readAsDataURL(blob);
    });
  }
}
